<div class="layout-container">
	<app-header (toggleSidebar)="onToggleSidebar()"></app-header>
	<mat-sidenav-container class="sidenav-container">
		<mat-sidenav
			mode="side"
			[opened]="isSidebarOpen"
			class="sidenav"
			[fixedInViewport]="true"
			[fixedTopGap]="64"
		>
			<!-- Surveys Section -->
			<div class="menu-section" *ngIf="isRouteActive('/cohorts')">
				<div class="section-header">
					<mat-icon>assessment</mat-icon>
					Surveys
				</div>
				<mat-nav-list>
					<a
						mat-list-item
						routerLink="/cohorts"
						routerLinkActive="active"
						[routerLinkActiveOptions]="{ exact: true }"
					>
						<mat-icon matListItemIcon>list</mat-icon>
						<span matListItemTitle>All Surveys</span>
					</a>
				</mat-nav-list>
			</div>
		</mat-sidenav>
		<mat-sidenav-content>
			<main class="content">
				<router-outlet></router-outlet>
			</main>
		</mat-sidenav-content>
	</mat-sidenav-container>
</div>
